<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<div class="top-bar">
  <div class="top-bar__start">
    <app-logo></app-logo>
  </div>
  <div class="top-bar__end">
    <div class="connection-pill" *ngIf="!onlineOfflineService.isOnlineValue" [title]="'preferredOrg.offlinePillTitle' | translate">
      <icon name="cloud_off" width="18" height="18"></icon>{{ 'preferredOrg.offlinePill' | translate }}
    </div>
    <button id="btn_help" mat-icon-button [matMenuTriggerFor]="helpMenu" *ngIf="helpersService.isDesktop">
      <icon name="help"></icon>
    </button>
    <button mat-button id="btn_accountSettings" class="margin-start-base padding-y-xs" [matMenuTriggerFor]="menu"
      #clickMenuTrigger="matMenuTrigger" *ngIf="helpersService.isDesktop">
      <app-user-profile [userProfile]="userProfile" [currentOrganization]="currentOrganization"></app-user-profile>
    </button>
    <button mat-icon-button id="btn_accountSettings" class="padding-y-xs" [matMenuTriggerFor]="menu"
      #clickMenuTrigger="matMenuTrigger" *ngIf="!helpersService.isDesktop">
      <img class="user-profile__mob-avatar" [src]="userProfile?.picture">
    </button>
    <mat-menu (closed)="closedMenu()" #menu="matMenu" xPosition="before"
      [class]="'user-menu user-menu--organization-'+(isSwitchOrganization || isPreviewFeatures)">
      <div
        [ngClass]="isSwitchOrganization || isSwitchLanguage || isPreviewFeatures? 'user-menu__hide' : 'user-menu__show'">
        <div class="margin-bottom-base">
          <app-user-profile [userProfile]="userProfile" [currentOrganization]="currentOrganization"></app-user-profile>
        </div>
        <mat-divider></mat-divider>
        <a id="btn_switchLanguage" mat-menu-item (click)="$event.stopPropagation(); showSwitchLanguage()">
          <icon class="margin-end-s" name="public"></icon>
          <span class="margin-end-xxl">{{ 'topBar.menu.changeLanguage' | translate }}</span>
          <icon class="menu-arrow" name="arrow_right"></icon>
        </a>
        <a id="btn_userProfile" mat-menu-item (click)="$event.stopPropagation();">
          <icon class="margin-end-s" name="person"></icon>
          <span>{{ 'topBar.menu.userProfile' | translate }}</span>
        </a>
        <a id="btn_billingAccount" mat-menu-item (click)="$event.stopPropagation();">
          <icon class="margin-end-s" name="paid"></icon>
          <span>{{ 'topBar.menu.billingAccount' | translate }}</span>
        </a>
        <a id="btn_passCode" mat-menu-item [routerLink]="['/set-pass-code']">
          <icon class="margin-end-s" name="lock"></icon>
          <span>{{ 'topBar.menu.passCode' | translate }}</span>
        </a>
        <a id="btn_previewFeatures" mat-menu-item (click)="$event.stopPropagation();showPreviewFeatures()">
          <icon class="margin-end-s" name="star"></icon>
          <span class="margin-end-xxl">{{ 'topBar.menu.previewFeatures' | translate }}</span>
          <icon class="menu-arrow" name="arrow_right"></icon>
        </a>
        <mat-divider></mat-divider>
        <a id="btn_switchOrganization" mat-menu-item class="margin-y-s"
          (click)="$event.stopPropagation();showSwitchOrganization()"
          *ngIf="authService.userOrganizations.length > 1">
          <icon class="margin-end-s" name="work"></icon>
          <span class="">{{ 'topBar.menu.switchOrganization' | translate }}</span>
          <icon class="menu-arrow" name="arrow_right"></icon>
        </a>
        <mat-divider></mat-divider>
        <div class="margin-top-base">
          <button id="btn_signOut" mat-button color="primary" (click)="logout()" class="button--block">
            {{ 'topBar.menu.signOut' | translate }}
          </button>
        </div>
      </div>
      <div [ngClass]="isSwitchOrganization ? 'user-menu__show' : 'user-menu__hide'" class="user-menu__inner">
        <app-organization-switcher *ngIf="isSwitchOrganization" (closed)="closeMenu()"
          (backToMenu)="showSwitchOrganization()"></app-organization-switcher>
      </div>
      <div [ngClass]="isPreviewFeatures ? 'user-menu__show' : 'user-menu__hide'" class="user-menu__inner">
        <div class="d-flex">
          <button id="btn_back" mat-icon-button
            (click)="$event.stopPropagation();isPreviewFeatures = !isPreviewFeatures">
            <icon name="chevron_left" class="user-menu__inner-icon"></icon>
          </button>
          <h3 class="user-menu__inner-title margin-bottom-none">{{ 'topBar.menu.previewFeatures' | translate }}</h3>
        </div>
        <app-preview-features (click)="$event.stopPropagation();"></app-preview-features>
      </div>
      <div [ngClass]="isSwitchLanguage ? 'user-menu__show' : 'user-menu__hide'" class="user-menu__inner">
        <div class="d-flex">
          <button id="btn_back" mat-icon-button (click)="$event.stopPropagation();isSwitchLanguage = !isSwitchLanguage">
            <icon name="chevron_left" class="user-menu__inner-icon"></icon>
          </button>
          <h3 class="user-menu__inner-title margin-bottom-none">
            {{ 'topBar.menu.changeLanguage' | translate }}
          </h3>
        </div>
        <div class="padding-bottom-m">
          <button id="btn_languageEn" mat-menu-item (click)="switchLanguageService.useLanguage('en')"
            [ngClass]="{'user-menu__inner-button--selected': switchLanguageService.currentLanguage === 'en'}">
            <span>English</span>
            <icon name="done" class="user-menu__inner-checked-icon"></icon>
          </button>
          <button id="btn_languageAr" mat-menu-item (click)="switchLanguageService.useLanguage('ar')"
            [ngClass]="{'user-menu__inner-button--selected': switchLanguageService.currentLanguage === 'ar'}">
            <span>العربية</span>
            <icon name="done" class="user-menu__inner-checked-icon"></icon>
          </button>
        </div>
      </div>
    </mat-menu>
    <mat-menu #helpMenu="matMenu" xPosition="before">
      <button id="btn_info" mat-menu-item (click)="help()">
        <icon name="info" class="margin-end-s"></icon>
        <span>{{ 'topBar.help.keyboardShortcuts' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>